import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Phone, Mail, MapPin, Clock } from 'lucide-react';
import { companyInfo, services } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-zinc-900 text-white">
      {/* Main Footer */}
      <div className="border-t-4 border-orange-500">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-12 lg:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center mb-6">
                <img 
                  src="/images/Logo/website_logo.png" 
                  alt="The House of Renovation and Design"
                  className="h-12 w-auto"
                />
              </Link>
              <p className="text-zinc-400 text-sm leading-relaxed mb-6">
                Quality craftsmanship for Halifax & HRM. No shortcuts. No excuses. Just solid work.
              </p>
              <div className="flex gap-3">
                <a
                  href={companyInfo.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-zinc-800 border border-zinc-700 flex items-center justify-center hover:bg-orange-500 hover:border-orange-500 transition-colors text-zinc-400 hover:text-white"
                >
                  <Facebook className="w-4 h-4" />
                </a>
                <a
                  href={companyInfo.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-zinc-800 border border-zinc-700 flex items-center justify-center hover:bg-orange-500 hover:border-orange-500 transition-colors text-zinc-400 hover:text-white"
                >
                  <Instagram className="w-4 h-4" />
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-white font-black text-sm uppercase tracking-wide mb-6 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-orange-500"></span>
                Services
              </h3>
              <ul className="space-y-3">
                {services.map((service) => (
                  <li key={service.id}>
                    <span className="text-zinc-400 text-sm hover:text-orange-500 transition-colors cursor-default">
                      {service.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-white font-black text-sm uppercase tracking-wide mb-6 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-orange-500"></span>
                Company
              </h3>
              <ul className="space-y-3">
                <li><Link to="/" className="text-zinc-400 text-sm hover:text-orange-500 transition-colors">Home</Link></li>
                <li><Link to="/projects" className="text-zinc-400 text-sm hover:text-orange-500 transition-colors">Our Work</Link></li>
                <li><Link to="/about" className="text-zinc-400 text-sm hover:text-orange-500 transition-colors">About Us</Link></li>
                <li><Link to="/contact" className="text-zinc-400 text-sm hover:text-orange-500 transition-colors">Contact</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-white font-black text-sm uppercase tracking-wide mb-6 flex items-center gap-2">
                <span className="w-8 h-0.5 bg-orange-500"></span>
                Contact
              </h3>
              <ul className="space-y-4">
                <li>
                  <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-3 text-zinc-400 hover:text-orange-500 transition-colors text-sm">
                    <Phone className="w-4 h-4 text-orange-500" />
                    {companyInfo.phone}
                  </a>
                </li>
                <li>
                  <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-3 text-zinc-400 hover:text-orange-500 transition-colors text-sm">
                    <Mail className="w-4 h-4 text-orange-500" />
                    {companyInfo.email}
                  </a>
                </li>
                <li className="flex items-start gap-3 text-zinc-400 text-sm">
                  <MapPin className="w-4 h-4 text-orange-500 mt-0.5" />
                  <span>Halifax & HRM, Nova Scotia</span>
                </li>
                <li className="flex items-start gap-3 text-zinc-400 text-sm">
                  <Clock className="w-4 h-4 text-orange-500 mt-0.5" />
                  <span>Mon-Fri: 8:30am - 5pm</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-xs uppercase tracking-wide">
            © {new Date().getFullYear()} The House of Renovation and Design
          </p>
          <p className="text-zinc-500 text-xs uppercase tracking-wide">
            Built Right. Built to Last.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;